<script>
import { Doughnut } from 'vue-chartjs'
function catchClickEvent(self,evt,item){
    self.$emit('itemclicked',evt,item);
}
export default {
    extends: Doughnut,
    props: {
        data: {
            type: Object,
            default: null,
        },
        options: {
            type: Object,
            default: null,
        }
    },
    data(){
        return{
        }
    },
    methods:{
    },
    mounted() {
        // this.options.onclick = (event,item) =>{this.$emit('itemclicked',event,item)};
        var self = this;
        var click = { 
            'onClick' : function (evt, item) {
                catchClickEvent(self,evt,item);
            }
        }
        const finalResult = Object.assign(this.options,click);
        this.renderChart(this.data, finalResult)
    }
}
</script>